// constants.js

//export const BASE_URL = "http://13.233.84.104:3001"; /// old api id

//export const BASE_URL = "http://65.1.135.126:3001";

//export const BASE_URL = "http://localhost:3001"; //// Local

export const BASE_URL = "https://api-eschool.anzasoftware.in"; /// VPS

// export const BASE_URL =
//   process.env.NODE_ENV === "production"
//     ? process.env.API_URL
//     : "http://localhost:3001";

export const SESSION_DURATION = 4 * 60 * 60 * 1000;  /// 4 hours

export const GBL_TRD_UPLD = '55'
export const GBL_MST_IMP = '56'
export const GBL_GRO_MST = '210'
export const GBL_BOOK_TYPE_MST = '211'
export const GBL_C_B_MST = '212'
export const GBL_ACC_MST = '213'
export const GBL_NARR_MST = '214'
export const GBL_OPN_BAL = '231'
export const GBL_PAY_RCPT = '232'
export const GBL_JV = '233'
export const GBL_SETTLE_JV = '234'
export const GBL_DR_CR = '235'
export const GBL_CONTRA = '236'
export const GBL_TRANS_B_RECO = '237'
export const GBL_FND_PAYOUT = '238'
export const GBL_EPI_FND = '239'
export const GBL_DAY_BOOK = '281'
export const GBL_C_B_BOOK = '282'
export const GBL_REPORT_B_RECO = '283'
export const GBL_TRIAL_BAL = '284'
export const GBL_LEDGER = '285'
export const GBL_MII_MAST = '401'
export const GBL_VENDOER_MAST = '402'
export const GBL_ACTIVITY_MAST = '403'
export const GBL_SEG_MAST = '404'
export const GBL_DOC_MAST = '405'
export const GBL_HOLIDAY_MAST = '406'
export const GBL_COMP_MAST = '407'
export const GBL_CLI_REG = '605'
export const GBL_BROK_SLAB = '606'
export const GBL_CLIENT_SLAB = '607'
export const GBL_SUB_DEALER = '608'
export const GBL_SLAB_DEALER = '609'
export const GBL_FAM_GRP = '610'
export const GBL_CLIENT_GRP = '611'
export const GBL_CONT_PERSON = '612'
export const GBL_SEC_PAYIN = '710'
export const GBL_HOLD_STATE = '810'
export const GBL_DAILY_CLNT_MAR = '910'
export const GBL_DAILY_NSE_MAR = '911'
export const GBL_DAILY_COLLAT_REPORT = '951'
export const GBL_COLLAT_LOGS = '952'
export const GBL_DILY_CASH_BAL = '953'
export const GBL_USER_CREATION = '971'
export const GBL_ROLE_CREATION = '972'
export const GBL_CHANGE_PASS = '973'
export const GBL_RESET_PASS_USER = '974'


